export class SsoErrors {
  public notAuthorized(): string {
    return 'This feature requires authorization. Please contact Customer Service.';
  }

  public serviceUnavailable(): string {
    return 'Verification service unavailable.';
  }

  public syncFailed(): string {
    return 'Session synchronization failed.';
  }
}
